var map = {
	"./CanvasClear": 404,
	"./CanvasClear.ts": 404,
	"./CanvasMove": 228,
	"./CanvasMove.ts": 228,
	"./CommandAbstract": 570,
	"./CommandAbstract.ts": 570,
	"./ComponentDelete": 377,
	"./ComponentDelete.ts": 377,
	"./ComponentDrag": 728,
	"./ComponentDrag.ts": 728,
	"./ComponentEnter": 462,
	"./ComponentEnter.ts": 462,
	"./ComponentExit": 658,
	"./ComponentExit.ts": 658,
	"./ComponentNext": 619,
	"./ComponentNext.ts": 619,
	"./ComponentPrev": 935,
	"./ComponentPrev.ts": 935,
	"./ComponentStyleClear": 536,
	"./ComponentStyleClear.ts": 536,
	"./CopyComponent": 957,
	"./CopyComponent.ts": 957,
	"./ExportTemplate": 413,
	"./ExportTemplate.ts": 413,
	"./Fullscreen": 516,
	"./Fullscreen.ts": 516,
	"./MoveComponent": 13,
	"./MoveComponent.ts": 13,
	"./OpenAssets": 204,
	"./OpenAssets.ts": 204,
	"./OpenBlocks": 195,
	"./OpenBlocks.ts": 195,
	"./OpenLayers": 671,
	"./OpenLayers.ts": 671,
	"./OpenStyleManager": 49,
	"./OpenStyleManager.ts": 49,
	"./OpenTraitManager": 590,
	"./OpenTraitManager.ts": 590,
	"./PasteComponent": 483,
	"./PasteComponent.ts": 483,
	"./Preview": 857,
	"./Preview.ts": 857,
	"./Resize": 869,
	"./Resize.ts": 869,
	"./SelectComponent": 194,
	"./SelectComponent.ts": 194,
	"./SelectPosition": 582,
	"./SelectPosition.ts": 582,
	"./ShowOffset": 131,
	"./ShowOffset.ts": 131,
	"./SwitchVisibility": 229,
	"./SwitchVisibility.ts": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 585;